import { createRouterSelector } from '@atlassian/react-resource-router';

export const useIsCurrentRouteRedirect = createRouterSelector<boolean>(
	({ route: currentRoute }) => currentRoute.isRedirect ?? false,
);
